import {
  FETCH_SPECIFIC_ASSESSMENT_STUDENT_LIST_REQUEST,
  FETCH_SPECIFIC_ASSESSMENT_STUDENT_LIST_SUCCESS,
  FETCH_SPECIFIC_ASSESSMENT_STUDENT_LIST_FAILURE,
  SET_LOADING,
  SET_ERROR,
  SET_ACTIVE_ASSESSMENT_COUNT,
  SET_ASSESSMENT_COMPLETED_COUNT,
  SET_ACTIVE_ASSESSMENTS,
  SET_COMPLETED_ASSESSMENTS,
  SET_ACTIVE_ASSESSMENTS_PAGINATION,
  SET_COMPLETED_ASSESSMENTS_PAGINATION,
  SET_ACTIVE_ASSESSMENTS_METRICS,
  SET_COMPLETED_ASSESSMENTS_METRICS,
  SET_FILTERS,
  UPDATE_PAGE,
  SET_STUDENT_DATA_SENT,
  SET_STUDENT_DATA_PENDING,
  SET_STUDENT_DATA_IN_PROGRESS,
  SET_STUDENT_DATA_DROPPED_OFF,
  SET_STUDENT_DATA_COMPLETED,
  SET_STUDENT_DATA_LOADING,
  SET_ASSESSMENT_FILTERS,
  SET_CHART_FILTERS,
  CLEAR_CHART_FILTERS,
  // Add Activity Tracker action types
  FETCH_ACTIVITY_MAP_REQUEST,
  FETCH_ACTIVITY_MAP_SUCCESS,
  FETCH_ACTIVITY_MAP_FAILURE,
  SET_ACTIVITY_DATE_RANGE,
  FETCH_PRACTICE_SCORES_REQUEST,
  FETCH_PRACTICE_SCORES_SUCCESS,
  FETCH_PRACTICE_SCORES_FAILURE,
  // Add aptitude practice scores imports
  FETCH_APTITUDE_PRACTICE_SCORES_REQUEST,
  FETCH_APTITUDE_PRACTICE_SCORES_SUCCESS,
  FETCH_APTITUDE_PRACTICE_SCORES_FAILURE,
  // Add actual assessment scores imports
  FETCH_PRACTICE_SCORES2_REQUEST,
  FETCH_PRACTICE_SCORES2_SUCCESS,
  FETCH_PRACTICE_SCORES2_FAILURE,
  FETCH_APTITUDE_PRACTICE_SCORES2_REQUEST,
  FETCH_APTITUDE_PRACTICE_SCORES2_SUCCESS,
  FETCH_APTITUDE_PRACTICE_SCORES2_FAILURE,
  FETCH_COMPLETED_PRACTICE_ASSESSMENTS_REQUEST,
  FETCH_COMPLETED_PRACTICE_ASSESSMENTS_SUCCESS,
  FETCH_COMPLETED_PRACTICE_ASSESSMENTS_FAILURE,
  FETCH_LAST_ASSESSMENT_REQUEST,
  FETCH_LAST_ASSESSMENT_SUCCESS,
  FETCH_LAST_ASSESSMENT_FAILURE,
  FETCH_LAST_PRACTICE_REQUEST,
  FETCH_LAST_PRACTICE_SUCCESS,
  FETCH_LAST_PRACTICE_FAILURE,
  FETCH_CEFR_LEVEL_REQUEST,
  FETCH_CEFR_LEVEL_SUCCESS,
  FETCH_CEFR_LEVEL_FAILURE,
  FETCH_REPORTS_REQUEST,
  FETCH_REPORTS_SUCCESS,
  FETCH_REPORTS_FAILURE,

  FETCH_MEDIA_KEYS_REQUEST,
  FETCH_MEDIA_KEYS_SUCCESS,
  FETCH_MEDIA_KEYS_FAILURE,
  FETCH_MEDIA_URLS_REQUEST,
  FETCH_MEDIA_URLS_SUCCESS,
  FETCH_MEDIA_URLS_FAILURE,
  RESET_MEDIA_STATE,

  CHECK_REPORT_AVAILABILITY_REQUEST,
  CHECK_REPORT_AVAILABILITY_SUCCESS,
  CHECK_REPORT_AVAILABILITY_FAILURE,
  FETCH_ASSESSMENT_DETAILS_REQUEST,
  FETCH_ASSESSMENT_DETAILS_SUCCESS,
  FETCH_ASSESSMENT_DETAILS_FAILURE,
  // Chart data action types
  FETCH_ASSESSMENT_CHARTS_REQUEST,
  FETCH_ASSESSMENT_CHARTS_SUCCESS,
  FETCH_ASSESSMENT_CHARTS_FAILURE,
  FETCH_ASSESSMENT_STATES_REQUEST,
  FETCH_ASSESSMENT_STATES_SUCCESS,
  FETCH_ASSESSMENT_STATES_FAILURE,
  FETCH_TPO_STUDENT_LIST_REQUEST,
  FETCH_TPO_STUDENT_LIST_SUCCESS,
  FETCH_TPO_STUDENT_LIST_FAILURE,
  // Diagnosis data action types
  FETCH_DIAGNOSIS_DATA_REQUEST,
  FETCH_DIAGNOSIS_DATA_SUCCESS,
  FETCH_DIAGNOSIS_DATA_FAILURE,
} from './actions'

const INITIAL_STATE = {
  // Common states
  loading: false,
  error: null,

  // Common counts
  activeAssessmentCount: 0,
  assessmentCompletedCount: 0,

  // Active assessments array
  activeAssessments: [],
  // Active assessments pagination
  activeAssessmentsPagination: {
    page: 1,
    limit: 10,
    totalPages: 1,
    totalItems: 0,
    currentCount: 0,
  },
  // Active assessments metrics
  activeAssessmentsMetrics: {
    total: 0,
    completed: 0,
    pending: 0,
  },

  // Completed assessments array
  completedAssessments: [],
  // Completed assessments pagination
  completedAssessmentsPagination: {
    page: 0,
    limit: 10,
    totalPages: 1,
    totalItems: 0,
    currentCount: 0,
  },
  // Completed assessments metrics
  completedAssessmentsMetrics: {
    total: 0,
    completedOnTime: 0,
    completedLate: 0,
    infoCards: {
      totalCandidates: 0,
      totalAssessmentsSent: 0,
      totalAssessmentsTaken: 0,
      totalPracticeTests: 0,
    },
  },
  specificAssessmentStudentList: {
    data: [],
    totalCount: 0,
    loading: false,
    error: null,
  },

  // Common filters
  filters: {
    searchBy: '',
    order: 'createdAt',
    sort: 'desc',
    pageNo: 0,
    pageLimit: 10,
    isTrial: false,
    isSubscribed: false,
    states: [],
    cities: [],
    type_name: '',
    entityType: 'college',
  },

  // Student data state
  studentData: {
    sent: [],
    pending: [],
    inProgress: [],
    droppedOff: [],
    completed: [],
  },
  studentDataLoading: false,
  studentDataError: null,
  studentDataPagination: null,

  // TPO Dashboard Student List
  tpoStudentList: [],
  tpoStudentListPagination: {
    totalCount: 0,
    pageNumber: 1,
    pageSize: 10,
  },
  tpoStudentListLoading: false,
  tpoStudentListError: null,

  // TPO Dashboard Student List
  tpoStudentList: [],
  tpoStudentListPagination: {
    totalCount: 0,
    pageNumber: 1,
    pageSize: 10,
  },
  tpoStudentListLoading: false,
  tpoStudentListError: null,

  // Assessment filters
  assessmentFilters: {
    passingYear: '',
    specialization: '',
  },

  // Chart-based filters
  chartFilters: {
    cefrLevel: null,      // A1, A2, B1, B2, C1, C2
    aptitudeLevel: null,  // Beginner, Learner, Competent, Advanced
    consistency: null,    // highconsistency, moderateconsistency, inconsistent
    assessmentType: null, // Communication, Aptitude
  },

  // Chart data state
  chartData: null,
  chartLoading: false,
  chartError: null,

  // Activity map state (added from Assessment-React)
  activityData: [],
  activityLoading: false,
  activityError: null,
  activityDateRange: {
    startDate: null,
    endDate: null,
  },

  practiceScores: {
    data: [],
    dayZero: null,
    loading: false,
    error: null,
  },
  // Add aptitude practice scores state
  aptitudePracticeScores: {
    data: [],
    dayZero: null,
    loading: false,
    error: null,
  },
  // Add actual assessment scores state (is_practice=false)
  assessmentScores: {
    data: [],
    dayZero: null,
    loading: false,
    error: null,
  },
  // Add actual aptitude assessment scores state (is_practice=false)
  aptitudeAssessmentScores: {
    data: [],
    dayZero: null,
    loading: false,
    error: null,
  },
  completedPracticeAssessments: {
    data: [],
    pagination: null,
    loading: false,
    error: null,
  },

  // Add these new state properties
  lastAssessment: {
    data: null,
    loading: false,
    error: null,
  },
  lastPractice: {
    data: null,
    loading: false,
    error: null,
  },

  // Add this new state property
  cefrLevel: {
    data: null,
    loading: false,
    error: null,
  },

  // Add reports state
  reports: {
    data: [],
    loading: false,
    error: null,
  },

  // Add aptitude specific state
  aptitudeMetrics: {
    data: {
      aptitudeCompleted: 0,
      aptitudeTotal: 0,
      aptitudePending: 0,
    },
    loading: false,
    error: null,
  },

  // Diagnosis data state
  diagnosisData: {
    students: [],
    totalCount: 0,
    completedDiagnosisCount: 0,
    pageNumber: 1,
    pageSize: 10,
    assessmentType: null,
    loading: false,
    error: null,
  },
}






export default function SubscribedInstitutes(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        loading: action.status,
      }

    case SET_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      }

    case SET_ACTIVE_ASSESSMENT_COUNT:
      return {
        ...state,
        activeAssessmentCount: action.count,
      }

    case SET_ASSESSMENT_COMPLETED_COUNT:
      return {
        ...state,
        assessmentCompletedCount: action.count,
        error: null,
      }

    case SET_ACTIVE_ASSESSMENTS:
      return {
        ...state,
        activeAssessments: action.assessments,
        error: null,
      }

    case SET_COMPLETED_ASSESSMENTS:
      return {
        ...state,
        completedAssessments: action.assessments,
        error: null,
      }

    case SET_ACTIVE_ASSESSMENTS_PAGINATION:
      return {
        ...state,
        activeAssessmentsPagination: {
          ...state.activeAssessmentsPagination,
          ...action.pagination,
        },
      }

    case SET_COMPLETED_ASSESSMENTS_PAGINATION:
      return {
        ...state,
        completedAssessmentsPagination: {
          ...state.completedAssessmentsPagination,
          ...action.pagination,
        },
      }

    case SET_ACTIVE_ASSESSMENTS_METRICS:
      return {
        ...state,
        activeAssessmentsMetrics: {
          ...state.activeAssessmentsMetrics,
          ...action.metrics,
        },
      }

    case SET_COMPLETED_ASSESSMENTS_METRICS:
      return {
        ...state,
        completedAssessmentsMetrics: {
          ...state.completedAssessmentsMetrics,
          ...action.metrics,
        },
      }

    case SET_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.filters,
          pageNo: action.filters.pageNo ?? 0,
        },
      }

    case UPDATE_PAGE:
      return {
        ...state,
        filters: {
          ...state.filters,
          pageNo: action.page,
        },
      }

    case SET_STUDENT_DATA_SENT:
      return {
        ...state,
        studentData: {
          ...state.studentData,
          sent: action.students,
        },
      }

    case SET_STUDENT_DATA_PENDING:
      return {
        ...state,
        studentData: {
          ...state.studentData,
          pending: action.students,
        },
      }

    case SET_STUDENT_DATA_IN_PROGRESS:
      return {
        ...state,
        studentData: {
          ...state.studentData,
          inProgress: action.students,
        },
      }

    case SET_STUDENT_DATA_DROPPED_OFF:
      return {
        ...state,
        studentData: {
          ...state.studentData,
          droppedOff: action.students,
        },
      }

    case SET_STUDENT_DATA_COMPLETED:
      return {
        ...state,
        studentData: {
          ...state.studentData,
          completed: action.students,
        },
      }

    case SET_STUDENT_DATA_LOADING:
      return {
        ...state,
        studentDataLoading: action.status,
      }

    case SET_ASSESSMENT_FILTERS:
      return {
        ...state,
        assessmentFilters: {
          ...state.assessmentFilters,
          ...action.filters,
        },
      }



    case CLEAR_CHART_FILTERS:
      return {
        ...state,
        chartFilters: {
          cefr: null,
          aptitudeLevel: null,
          consistency: null,
          assessmentType: null,
        },
      }

    // Activity map cases (copied from Assessment-React)
    case FETCH_ACTIVITY_MAP_REQUEST:
      return {
        ...state,
        activityLoading: true,
        activityError: null,
      }

    case FETCH_ACTIVITY_MAP_SUCCESS:
      return {
        ...state,
        activityLoading: false,
        activityData: action.payload,
        activityError: null,
      }

    case FETCH_ACTIVITY_MAP_FAILURE:
      return {
        ...state,
        activityLoading: false,
        activityError: action.payload,
        activityData: [],
      }

    case FETCH_ASSESSMENT_DETAILS_REQUEST:
      return {
        ...state,
        studentDataLoading: true,
        studentDataError: null,
      }
    case FETCH_ASSESSMENT_DETAILS_SUCCESS:
      {
        // Merge per slice and avoid overwriting with empty arrays
        const incoming = action.payload.studentData || {}
        const prev = state.studentData || {}
        const keys = ['sent', 'pending', 'inProgress', 'droppedOff', 'completed', 'notStarted']
        const merged = { ...prev }
        keys.forEach(k => {
          const nextArr = incoming[k]
          if (Array.isArray(nextArr)) {
            if (nextArr.length > 0) {
              merged[k] = nextArr
            } // else keep previous slice as-is
          } else if (typeof nextArr !== 'undefined') {
            // If backend sends a non-array truthy value, fallback to previous
            merged[k] = Array.isArray(prev[k]) ? prev[k] : []
          } else {
            // key not present -> keep previous
            merged[k] = Array.isArray(prev[k]) ? prev[k] : []
          }
        })

        return {
          ...state,
          studentDataLoading: false,
          studentData: merged,
          studentDataPagination: action.payload.pagination || state.studentDataPagination || null,
        }
      }
    case FETCH_ASSESSMENT_DETAILS_FAILURE:
      return {
        ...state,
        studentDataLoading: false,
        studentDataError: action.payload,
        studentData: INITIAL_STATE.studentData,
        studentDataPagination: null,
      }

    case SET_ACTIVITY_DATE_RANGE:
      return {
        ...state,
        activityDateRange: action.payload,
      }

    case FETCH_PRACTICE_SCORES_REQUEST:
      return {
        ...state,
        practiceScores: {
          ...state.practiceScores,
          loading: true,
          error: null,
        },
      }

    case FETCH_PRACTICE_SCORES_SUCCESS:
      return {
        ...state,
        practiceScores: {
          loading: false,
          error: null,
          data: action.payload.data || action.payload,
          dayZero: action.payload.dayZero || null,
        },
      }

    case FETCH_PRACTICE_SCORES_FAILURE:
      return {
        ...state,
        practiceScores: {
          ...state.practiceScores,
          loading: false,
          error: action.payload,
        },
      }

    // Add aptitude practice scores cases
    case FETCH_APTITUDE_PRACTICE_SCORES_REQUEST:
      return {
        ...state,
        aptitudePracticeScores: {
          ...state.aptitudePracticeScores,
          loading: true,
          error: null,
        },
      }

    case FETCH_APTITUDE_PRACTICE_SCORES_SUCCESS:
      return {
        ...state,
        aptitudePracticeScores: {
          loading: false,
          error: null,
          data: action.payload?.data || action.payload || [],
          dayZero: action.payload?.dayZero || null,
        },
      }

    case FETCH_APTITUDE_PRACTICE_SCORES_FAILURE:
      return {
        ...state,
        aptitudePracticeScores: {
          ...state.aptitudePracticeScores,
          loading: false,
          error: action.payload,
        },
      }

    // Add actual assessment scores cases (is_practice=false)
    case FETCH_PRACTICE_SCORES2_REQUEST:
      return {
        ...state,
        assessmentScores: {
          ...state.assessmentScores,
          loading: true,
          error: null,
        },
      }

    case FETCH_PRACTICE_SCORES2_SUCCESS:
      return {
        ...state,
        assessmentScores: {
          loading: false,
          error: null,
          data: action.payload.data || action.payload,
          dayZero: action.payload.dayZero || null,
        },
      }

    case FETCH_PRACTICE_SCORES2_FAILURE:
      return {
        ...state,
        assessmentScores: {
          ...state.assessmentScores,
          loading: false,
          error: action.payload,
        },
      }

    // Add actual aptitude assessment scores cases (is_practice=false)
    case FETCH_APTITUDE_PRACTICE_SCORES2_REQUEST:
      return {
        ...state,
        aptitudeAssessmentScores: {
          ...state.aptitudeAssessmentScores,
          loading: true,
          error: null,
        },
      }

    case FETCH_APTITUDE_PRACTICE_SCORES2_SUCCESS:
      return {
        ...state,
        aptitudeAssessmentScores: {
          loading: false,
          error: null,
          data: action.payload?.data || action.payload || [],
          dayZero: action.payload?.dayZero || null,
        },
      }

    case FETCH_APTITUDE_PRACTICE_SCORES2_FAILURE:
      return {
        ...state,
        aptitudeAssessmentScores: {
          ...state.aptitudeAssessmentScores,
          loading: false,
          error: action.payload,
        },
      }

    case FETCH_COMPLETED_PRACTICE_ASSESSMENTS_REQUEST:
      return {
        ...state,
        completedPracticeAssessments: {
          ...state.completedPracticeAssessments,
          loading: true,
          error: null,
        },
      }

    case FETCH_COMPLETED_PRACTICE_ASSESSMENTS_SUCCESS:
      return {
        ...state,
        completedPracticeAssessments: {
          ...state.completedPracticeAssessments,
          loading: false,
          data: action.payload.assessments,
          pagination: action.payload.pagination,
          error: null,
        },
      }

    case FETCH_COMPLETED_PRACTICE_ASSESSMENTS_FAILURE:
      return {
        ...state,
        completedPracticeAssessments: {
          ...state.completedPracticeAssessments,
          loading: false,
          error: action.payload,
        },
      }

    case FETCH_LAST_ASSESSMENT_REQUEST:
      return {
        ...state,
        lastAssessment: {
          ...state.lastAssessment,
          loading: true,
          error: null,
        },
      }

    case FETCH_LAST_ASSESSMENT_SUCCESS:
      return {
        ...state,
        lastAssessment: {
          loading: false,
          error: null,
          data: action.payload,
        },
      }

    case FETCH_LAST_ASSESSMENT_FAILURE:
      return {
        ...state,
        lastAssessment: {
          ...state.lastAssessment,
          loading: false,
          error: action.payload,
        },
      }

    case FETCH_LAST_PRACTICE_REQUEST:
      return {
        ...state,
        lastPractice: {
          ...state.lastPractice,
          loading: true,
          error: null,
        },
      }

    case FETCH_LAST_PRACTICE_SUCCESS:
      return {
        ...state,
        lastPractice: {
          loading: false,
          error: null,
          data: action.payload,
        },
      }

    case FETCH_LAST_PRACTICE_FAILURE:
      return {
        ...state,
        lastPractice: {
          ...state.lastPractice,
          loading: false,
          error: action.payload,
        },
      }

    // Add these new cases
    case FETCH_CEFR_LEVEL_REQUEST:
      return {
        ...state,
        cefrLevel: {
          ...state.cefrLevel,
          loading: true,
          error: null,
        },
      }

    case FETCH_CEFR_LEVEL_SUCCESS:
      return {
        ...state,
        cefrLevel: {
          loading: false,
          error: null,
          data: action.payload,
        },
      }

    case FETCH_CEFR_LEVEL_FAILURE:
      return {
        ...state,
        cefrLevel: {
          ...state.cefrLevel,
          loading: false,
          error: action.payload,
        },
      }

    // Add these cases to your switch statement
    case 'FETCH_ASSESSMENT_SCORES_REQUEST':
      return {
        ...state,
        assessmentScoresLoading: true,
        assessmentScoresError: null,
      }

    case 'FETCH_ASSESSMENT_SCORES_SUCCESS':
      return {
        ...state,
        assessmentScores: action.payload,
        assessmentScoresLoading: false,
        assessmentScoresError: null,
      }

    case 'FETCH_ASSESSMENT_SCORES_FAILURE':
      return {
        ...state,
        assessmentScoresLoading: false,
        assessmentScoresError: action.payload,
      }

    case 'FETCH_STUDENT_ASSESSMENTS_REQUEST':
      return {
        ...state,
        studentAssessmentsLoading: true,
        studentAssessmentsError: null,
      }

    case 'FETCH_STUDENT_ASSESSMENTS_SUCCESS':
      return {
        ...state,
        studentAssessments: action.payload,
        studentAssessmentsLoading: false,
        studentAssessmentsError: null,
      }

    case FETCH_ASSESSMENT_STATES_REQUEST:
      return {
        ...state,
        loading: true,
      }

    case FETCH_ASSESSMENT_STATES_SUCCESS:
      return {
        ...state,
        loading: false,
        completedAssessmentsMetrics: {
          ...state.completedAssessmentsMetrics,
          infoCards: action.payload.data || action.payload, // Handle potential "data" nesting
        },
      }

    case FETCH_ASSESSMENT_STATES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    case FETCH_TPO_STUDENT_LIST_REQUEST:
      return {
        ...state,
        tpoStudentListLoading: true,
      }

    case FETCH_TPO_STUDENT_LIST_SUCCESS:
      return {
        ...state,
        tpoStudentListLoading: false,
        tpoStudentList: action.payload.data ? (action.payload.data.students || []) : [],
        tpoStudentListPagination: {
          totalCount: action.payload.data ? (action.payload.data.totalCount || 0) : 0,
          pageNumber: action.payload.data ? (action.payload.data.pageNumber || 1) : 1,
          pageSize: action.payload.data ? (action.payload.data.pageSize || 10) : 10,
        },
      }

    case FETCH_TPO_STUDENT_LIST_FAILURE:
      return {
        ...state,
        tpoStudentListLoading: false,
        tpoStudentListError: action.payload,
      }


    case 'FETCH_STUDENT_ASSESSMENTS_FAILURE':
      return {
        ...state,
        studentAssessmentsLoading: false,
        studentAssessmentsError: action.payload,
      }

    // Add these new cases
    case FETCH_REPORTS_REQUEST:
      return {
        ...state,
        reports: {
          ...state.reports,
          loading: true,
          error: null,
        },
      }

    case FETCH_REPORTS_SUCCESS:
      return {
        ...state,
        reports: {
          data: Array.isArray(action.payload) ? action.payload : [],
          loading: false,
          error: null,
        },
      }

    case FETCH_REPORTS_FAILURE:
      return {
        ...state,
        reports: {
          ...state.reports,
          loading: false,
          error: action.payload,
        },
      }

    case 'FETCH_SCORE_INFO_REQUEST':
      return {
        ...state,
        scoreInfoLoading: true,
        scoreInfoError: null,
      }

    case 'FETCH_SCORE_INFO_SUCCESS':
      return {
        ...state,
        scoreInfo: action.payload,
        scoreInfoLoading: false,
        scoreInfoError: null,
      }

    case 'FETCH_SCORE_INFO_FAILURE':
      return {
        ...state,
        scoreInfoLoading: false,
        scoreInfoError: action.payload,
      }

    case 'FETCH_APTITUDE_METRICS_REQUEST':
      return {
        ...state,
        aptitudeMetrics: {
          ...state.aptitudeMetrics,
          loading: true,
          error: null,
        }
      }

    case 'FETCH_APTITUDE_METRICS_SUCCESS':
      return {
        ...state,
        aptitudeMetrics: {
          data: action.payload,
          loading: false,
          error: null,
        }
      }

    case 'FETCH_APTITUDE_METRICS_FAILURE':
      return {
        ...state,
        aptitudeMetrics: {
          ...state.aptitudeMetrics,
          loading: false,
          error: action.payload,
        }
      }

    // Chart filter handlers
    case SET_CHART_FILTERS:
      return {
        ...state,
        chartFilters: {
          ...state.chartFilters,
          ...action.payload,
        },
      }

    case CLEAR_CHART_FILTERS:
      return {
        ...state,
        chartFilters: {
          cefrLevel: null,
          aptitudeLevel: null,
          consistency: null,
          assessmentType: null,
        },
      }

    // Chart data action handlers
    case FETCH_ASSESSMENT_CHARTS_REQUEST:
      return {
        ...state,
        chartLoading: true,
        chartError: null,
      }

    case FETCH_ASSESSMENT_CHARTS_SUCCESS:
      const updatedChartsState = {
        ...state,
        chartData: action.payload,
        chartLoading: false,
        chartError: null,
      }
      return updatedChartsState

    case FETCH_ASSESSMENT_CHARTS_FAILURE:
      return {
        ...state,
        chartData: null,
        chartLoading: false,
        chartError: action.payload,
      }

    case FETCH_SPECIFIC_ASSESSMENT_STUDENT_LIST_REQUEST:
      return {
        ...state,
        specificAssessmentStudentList: {
          ...state.specificAssessmentStudentList,
          loading: true,
          error: null,
        },
      }
    case FETCH_SPECIFIC_ASSESSMENT_STUDENT_LIST_SUCCESS:
      const dataObj = action.payload?.data?.students ? action.payload.data : (action.payload?.students ? action.payload : {})
      const newStudents = dataObj.students
      const newTotalCount = dataObj.totalCount
      return {
        ...state,
        specificAssessmentStudentList: {
          ...state.specificAssessmentStudentList,
          loading: false,
          data: Array.isArray(newStudents) ? newStudents : [],
          totalCount: newTotalCount || 0,
          pageNumber: dataObj.pageNumber || 1,
          pageSize: dataObj.pageSize || 10,
        },
      }
    case FETCH_SPECIFIC_ASSESSMENT_STUDENT_LIST_FAILURE:
      return {
        ...state,
        specificAssessmentStudentList: {
          ...state.specificAssessmentStudentList,
          loading: false,
          error: action.payload,
        },
      }

    default:
      return state
  }
}




// Initial state for media availability
const MEDIA_INITIAL_STATE = {
  loading: false,
  mediaFiles: [],
  mediaUrls: { audio: null, video: null },
  error: null,
  audioAvailable: false,
  videoAvailable: false,
  reportAvailable: false,
  checkingReportAvailability: false
}


// Reducer for handling media availability state
export const MediaState = (state = MEDIA_INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_MEDIA_KEYS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }

    case FETCH_MEDIA_KEYS_SUCCESS:
      return {
        ...state,
        loading: false,
        mediaFiles: action.payload.mediaFiles || [],
        audioAvailable: !!action.payload.audioAvailable,
        videoAvailable: !!action.payload.videoAvailable,
        error: null
      }

    case FETCH_MEDIA_KEYS_FAILURE:
      return {
        ...state,
        loading: false,
        mediaFiles: [],
        audioAvailable: false,
        videoAvailable: false,
        error: action.payload
      }

    case FETCH_MEDIA_URLS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }

    case FETCH_MEDIA_URLS_SUCCESS:
      return {
        ...state,
        loading: false,
        mediaUrls: action.payload,
        error: null
      }

    case FETCH_MEDIA_URLS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    // PDF Report availability actions  
    case CHECK_REPORT_AVAILABILITY_REQUEST:
      return {
        ...state,
        checkingReportAvailability: true,
        error: null
      }

    case CHECK_REPORT_AVAILABILITY_SUCCESS:
      return {
        ...state,
        checkingReportAvailability: false,
        reportAvailable: action.payload,
        error: null
      }

    case CHECK_REPORT_AVAILABILITY_FAILURE:
      return {
        ...state,
        checkingReportAvailability: false,
        reportAvailable: false,
        error: action.payload
      }

    case RESET_MEDIA_STATE:
      return MEDIA_INITIAL_STATE

    // Chart data reducer cases
    case FETCH_ASSESSMENT_CHARTS_REQUEST:
      return {
        ...state,
        chartLoading: true,
        chartError: null
      }

    case FETCH_ASSESSMENT_CHARTS_SUCCESS:
      return {
        ...state,
        chartLoading: false,
        chartData: action.payload,
        chartError: null
      }

    case FETCH_ASSESSMENT_CHARTS_FAILURE:
      return {
        ...state,
        chartLoading: false,
        chartData: null,
        chartError: action.payload
      }

    // Diagnosis data reducer cases
    case FETCH_DIAGNOSIS_DATA_REQUEST:
      return {
        ...state,
        diagnosisData: {
          ...state.diagnosisData,
          loading: true,
          error: null,
        },
      }

    case FETCH_DIAGNOSIS_DATA_SUCCESS:
      console.log('[REDUCER] FETCH_DIAGNOSIS_DATA_SUCCESS received with payload:', action.payload)
      const newDiagnosisData = {
        ...state.diagnosisData,
        loading: false,
        error: null,
        students: action.payload.students || [],
        totalCount: action.payload.totalCount || 0,
        completedDiagnosisCount: action.payload.completedDiagnosisCount || 0,
        pageNumber: action.payload.pageNumber || 1,
        pageSize: action.payload.pageSize || 10,
        assessmentType: action.payload.assessmentType || null,
        distributions: action.payload.distributions || null,
      }
      console.log('[REDUCER] New diagnosisData to return:', newDiagnosisData)
      console.log('[REDUCER] New diagnosisData.students:', newDiagnosisData.students)
      console.log('[REDUCER] New diagnosisData.students.length:', newDiagnosisData.students.length)
      const newState = {
        ...state,
        diagnosisData: newDiagnosisData,
      }
      console.log('[REDUCER] Returning new state with diagnosisData:', newState.diagnosisData)
      return newState

    case FETCH_DIAGNOSIS_DATA_FAILURE:
      return {
        ...state,
        diagnosisData: {
          ...state.diagnosisData,
          loading: false,
          error: action.payload,
        },
      }

    default:
      return state
  }
}
